"use strict"

import React from "react"

import { withAnnotationsConfig } from "../../../config/AnnotationConfigProvider"
import VerticalDashedLine from "./VerticalDashedLine"
import { withGraphState } from "../../../config/GraphConfigProvider"

function AnnotationsLayer({
  x,
  y,
  show_annotation_lines, // From withAnnotationsConfig
  show_annotations, // From withGraphState
  annotations,
}) {
  return (
    <>
      {show_annotation_lines && show_annotations && (
        <VerticalDashedLine
          x={x}
          y={y}
          arr={annotations}
          color={"var(--lanzalake-grey"}
          canToggleVisibility
        />
      )}
    </>
  )
}

export default withAnnotationsConfig(withGraphState(AnnotationsLayer))
